import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from '@actuar/platform/config';
import { applyAppConfig } from '@platform/bootstrap';
import { environment } from './environments/environment';
import { LIVE_PICKUP_APP_ROUTES } from '@apps/live-pickup';
import { configureDevExtremeLocalization } from '@shared/assets';

configureDevExtremeLocalization();
applyAppConfig({ title: 'Live Pickup' });
bootstrapApplication(AppComponent, appConfig(environment, LIVE_PICKUP_APP_ROUTES)).catch((err) =>
  console.error(err)
);
